import app from 'vue'

app.component('attribute-title', () => import('@/views/attribute/partials/Title.vue'))
app.component('box', () => import('@/layout/Box.vue'))
app.component('column', () => import('@/layout/grid/Column.vue'))
app.component('columns', () => import('@/layout/grid/Columns.vue'))
app.component('container', () => import('@/layout/grid/Container.vue'))
app.component('flex', () => import('@/layout/grid/Flex.vue'))
app.component('grid', () => import('@/layout/grid/Grid.vue'))
app.component('heading', () => import('@/layout/typography/Heading.vue'))
app.component('logo', () => import('@/layout/Logo.vue'))
app.component('email-input', () => import('@/layout/forms/user/EmailInput.vue'))
app.component('user-password-input', () => import('@/layout/forms/user/PasswordInput.vue'))
app.component('nav-link', () => import('@/layout/Link.vue'))
app.component('page-navigation', () => import('@/layout/PageNavigation'))
app.component('save-button', () => import('@/layout/buttons/SaveButton.vue'))
app.component('loader', () => import('@/components/Loader.vue'))
app.component('current-status', () => import('@/components/CurrentStatus.vue'))
app.component('env-keys', () => import('@/views/apps/Environment/partials/Keys.vue'))
app.component('finding-output', () => import('@/views/attribute/partials/FindingOutput.vue'))
app.component('git-branch', () => import('@/components/GitBranch.vue'))
app.component('laravel-version', () => import('@/components/LaravelVersion.vue'))
app.component('latest-finding', () => import('@/views/attribute/partials/LatestFinding.vue'))
app.component('local-env-count', () => import('@/components/LocalEnvCount.vue'))
app.component('logo', () => import('@/layout/Logo.vue'))
app.component('email-input', () => import('@/layout/forms/user/EmailInput.vue'))
app.component('user-password-input', () => import('@/layout/forms/user/PasswordInput.vue'))
app.component('name-input', () => import('@/layout/forms/common/NameInput'))
app.component('route', () => import('@/components/Route.vue'))
app.component('search-bar', () => import('@/components/SearchBar.vue'))
app.component('route-finding', () => import('@/views/finding/RouteFinding.vue'))
app.component('software-finding', () => import('@/views/finding/SoftwareFinding.vue'))
app.component('attribute-finding', () => import('@/views/finding/AttributeFinding.vue'))
app.component('cwe-vulnerability', () => import('@/views/finding/vulnerability/CweVulnerability.vue'))
app.component('vulnerability-vulnerability', () => import('@/views/finding/vulnerability/CveVulnerability.vue'))
app.component('vulnerable-title', () => import('@/components/VulnerableTitle.vue'))
app.component('vulnerable-description', () => import('@/components/VulnerableDescription.vue'))
app.component('resolved', () => import('@/components/Resolved.vue'))
app.component('false-positive', () => import('@/components/FalsePositive.vue'))
app.component('unresolved', () => import('@/components/Unresolved.vue'))
app.component('attribute-finding-value', () => import('@/components/finding/AttributeFindingValue.vue'))
app.component('audit-attribute-finding', () => import('@/views/audit/partials/findings/AuditAttributeFinding.vue'))
app.component('audit-route-finding', () => import('@/views/audit/partials/findings/AuditRouteFinding.vue'))
app.component('no-items-to-show', () => import('@/components/NoItemsToShow.vue'))
app.component('source-code-finding', () => import('@/components/finding/SourceCodeFinding.vue'))
app.component('risk-tag', () => import('@/components/RiskTag.vue'))
app.component('route-uri', () => import('@/components/Uri.vue'))
app.component('problem-count', () => import('@/components/ProblemCount.vue'))
app.component('view-app-link', () => import('@/components/ViewAppLink.vue'))
app.component('index-row', () => import('@/layout/indexes/IndexRow.vue'))
app.component('problems', () => import('./Problems.vue'))
